import React from "react";
import bookmark from "../../img/bookmark.svg";
import { connect } from "react-redux";
import decode from "jwt-decode";
import cookie from "js-cookie";
import { saveToken, setSignOut } from "../authentication/actions";
import { withRouter } from "react-router-dom";

const Header = (props) => {
  const { store } = props;

  if (!props.token || !props.token.access_token || !store) {
    return null;
  }

  console.log("props.token", props.token);

  const payload = decode(props.token.access_token);

  const logout = () => {
    props.setSignOut(true);
    cookie.set("tokenInfo", null);
    props.saveToken({}, true);
    props.history.push("/");
  };

  return (
    <div className="topHeader">
      <div
        className="responsiveNavBtn"
        onClick={() => {
          props.setShowResponsiveNav(true);
        }}
      >
        <span class="icon-menu"></span>
      </div>
      <div className="fullWidth publisherInfo font-size_20 extraBoldFont">
        <div className="profilePicture">
          <img src={store.logo} />
        </div>
        {store.name}
      </div>
      <div className="fullWidth publisherCode centerText">
        <div className="publisherCodeHandler">
          <div className="publisherBack boldFont">
            <img src={bookmark} />
          </div>
          <div className="publisherCodeContent whiteColor">
            کد ناشر
            <p className="font-size_28 extraBoldFont">{String(store.code).toUpperCase()}</p>
          </div>
        </div>
      </div>
      <div className="fullWidth mainProfileNav">
        <div className="profileNavHandler leftFloat">
          <div className="mainProfileInfo">
            <div className="profileName">
              <div className="profileUsername font-size_18 boldFont">
                {payload.fullName}
              </div>
              <div className="profilePosition lightFont grayColor">
                مدیر سیستم
              </div>
            </div>
          </div>
          <div
            className="exitFromAccount redColor font-size_12 boldFont centerText"
            onClick={(e) => logout()}
          >
            <span className="icon icon-exit font-size_24"></span>
            <p>خروج</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ token, store }) => ({
  token,
  store,
});

export default connect(mapStateToProps, { saveToken, setSignOut })(
  withRouter(Header)
);
